import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { ContractProfileEntity } from "../../types/ContractProfileEntity";
import { ContractProfileDtoToEntity } from "../mappers/ContractProfileDtoToEntity";
import { ContractProfileEntityToDto } from "../mappers/ContractProfileEntityToDto";

const ContractProfileApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        ContractProfileLoad: builder.query<ContractProfileEntity, FormQuery>({
            providesTags: [ResourceName.CONTRACT_PROFILES],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CONTRACT_PROFILES}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return ContractProfileDtoToEntity(response);
            },
        }),
        ContractProfileSave: builder.mutation<ContractProfileEntity, FormMutation<ContractProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CONTRACT_PROFILES}`;
                const method = "POST";

                const body = ContractProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.CONTRACT_PROFILES],
        }),
        ContractProfileUpdate: builder.mutation<ContractProfileEntity, FormMutation<ContractProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CONTRACT_PROFILES}/${mutation.data.id}`;
                const method = "PUT";

                const body = ContractProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.CONTRACT_PROFILES],
        }),
    }),
});

export const { useContractProfileLoadQuery, useContractProfileSaveMutation, useContractProfileUpdateMutation } = ContractProfileApi;
